import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "moduleId", "form", "title"]

  connect() {
    // The blank "new group" form as rendered, restored for New after an Edit loaded a group's form into the frame.
    this.blankForm = this.frame()?.innerHTML
  }

  frame() {
    return this.hasDialogTarget ? this.dialogTarget.querySelector("turbo-frame#template_group_modal_form") : null
  }

  open(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const moduleId = trigger?.dataset?.moduleId
    const formAction = trigger?.dataset?.formAction
    const formMethod = trigger?.dataset?.formMethod
    const formFields = trigger?.dataset?.formFields
    const modalTitle = trigger?.dataset?.modalTitle
    const frameSrc = trigger?.dataset?.frameSrc
    const frame = this.frame()

    if (this.hasTitleTarget) {
      const fallbackTitle = this.titleTarget.dataset.defaultTitle || this.titleTarget.textContent
      this.titleTarget.textContent = modalTitle || fallbackTitle
    }

    // Edit: the server renders the group's own form (ticks, logo preview, remove logo) into the dialog.
    if (frameSrc && frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
      frame.src = frameSrc
      this.showDialog()
      return
    }

    if (frame && this.blankForm != null) {
      frame.removeAttribute("src")
      frame.innerHTML = this.blankForm
    }

    const form = this.hasFormTarget ? this.formTarget : this.dialogTarget.querySelector("form")
    if (form) {
      form.reset()
      if (formAction) {
        form.action = formAction
      }
      this.applyMethod(form, formMethod)
      this.applyFields(form, formFields)
    }

    if (this.hasModuleIdTarget && moduleId) {
      this.moduleIdTarget.value = moduleId
    }

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  closeOnSuccess(event) {
    if (event.detail.success) {
      this.close()
    }
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }

  applyMethod(form, method) {
    const normalized = (method || "").toLowerCase()
    const existing = form.querySelector("input[name='_method']")

    if (!normalized || normalized === "post") {
      if (existing) {
        existing.remove()
      }
      return
    }

    if (existing) {
      existing.value = normalized
      return
    }

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = normalized
    form.appendChild(methodInput)
  }

  applyFields(form, fields) {
    if (!fields) {
      return
    }

    let parsed = null
    try {
      parsed = JSON.parse(fields)
    } catch {
      parsed = null
    }

    if (!parsed) {
      return
    }

    Object.entries(parsed).forEach(([key, value]) => {
      // A Rails check box comes with a hidden "0" of the same name before it; fill the box, not the hidden field.
      const input = form.querySelector(`input[type="checkbox"][name="template_group[${key}]"]`) ||
        form.querySelector(`[name="template_group[${key}]"]:not([type="hidden"])`)
      if (!input) {
        return
      }

      if (input.type === "checkbox") {
        input.checked = Boolean(value)
      } else {
        input.value = value == null ? "" : String(value)
      }
    })
  }
}
